/*****************************************************************
 ** Copyright (c) 帕加马直播预览
 ** 创建人:      ly
 ** 创建日期:    2020/10/10
 ** 修改人:
 ** 修改日期:
 ** 描 述: 全局只读配置
 **-----------------------------------------------------------------
 ******************************************************************/

import request from '@/utils/$x';

/**
 * 获取直播流信息(清晰度配置)
 */
export function getPlayUrls(params) {
  return request.http('/livePlay/getPlayUrls', {
    method: 'post',
    data: params,
  });
}

// 查询直播课程
export async function getLiveClassList(params) {
  return request.http('/livePlay/getLiveClassList', {
    method: 'post',
    data: params,
  });
}

// check流状态
export async function checkStatus(params) {
  return request.http(params, {
    method: 'get',
  });
}

/**
 * 保存提词器
 * @param {*} params
 * @returns
 */
export function saveTelePrompter(params) {
  return request.http('/livePlay/saveTelePrompter', {
    method: 'post',
    data: params,
  });
}

/**
 * 查询提词器
 * @param {*} params
 * @returns
 */
export function queryTelePrompter(params) {
  return request.http('/livePlay/queryTelePrompter', {
    method: 'post',
    data: params,
  });
}

/**
 * 用户登录
 * @param {*} params
 * @returns
 */
export function audienceLogin(params) {
  return request.http('/livePlay/audienceLogin', {
    method: 'post',
    data: params,
  });
}

/**
 *加入房间
 * @param {*} params
 * @returns
 */
export function joinChatroom(params) {
  return request.http('/livePlay/joinChatroom', {
    method: 'post',
    data: params,
  });
}
